import type { Ref } from 'react'
import { Symbol, type SymbolName } from './Symbol'

/**
 * Ein Knopf, der nur ein Zeichen zeigt.
 *
 * ⚠️ `label` ist Pflicht — der Typ erzwingt es. Ein Symbol ohne Namen ist für
 * eine Sprachausgabe ein leerer Knopf, und genau das passiert sonst überall
 * dort, wo das Zeichen „selbsterklärend" wirkt.
 *
 * `ref` wird durchgereicht (React 19 braucht dafür kein forwardRef mehr) —
 * der Sortiergriff der Aufgabenliste hängt daran.
 */
export function IconButton({
  name,
  label,
  variant = 'standard',
  className,
  ref,
  ...rest
}: {
  name: SymbolName
  label: string
  variant?: 'standard' | 'tonal'
  ref?: Ref<HTMLButtonElement>
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'>) {
  return (
    <button
      type="button"
      ref={ref}
      className={`iconbtn iconbtn--${variant}${className ? ` ${className}` : ''}`}
      aria-label={label}
      {...rest}
    >
      <Symbol name={name} />
    </button>
  )
}
